import { getSiteJobDescriptionsForPublicRemote } from '@flex-apis/recruiting';
import { useQueryFromRemote } from '@flex-packages/remote-hooks';

function useGetSiteJobDescriptionsForPublicRemote(requestParams, options) {
  return useQueryFromRemote({
    remote: getSiteJobDescriptionsForPublicRemote,
    extraParams: requestParams,
    options
  });
}

export { useGetSiteJobDescriptionsForPublicRemote };
//# sourceMappingURL=useGetSiteJobDescriptionsForPublicRemote.mjs.map
